document.addEventListener("DOMContentLoaded", function () {
  const imageWrappers = document.querySelectorAll(
    ".mobile-slider .image-wrapper"
  );
  const titleWrappers = document.querySelectorAll(
    ".mobile-slider .title-wrapper"
  );

  const observerOptions = {
    root: null,
    threshold: 0.5,
  };

  function handleIntersect(entries) {
    entries.forEach((entry) => {
      const index = entry.target.dataset.index - 1;

      if (entry.isIntersecting) {
        titleWrappers.forEach((title) => title.classList.remove("active"));
        if (titleWrappers[index]) {
          titleWrappers[index].classList.add("active");
        }
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersect, observerOptions);

  imageWrappers.forEach((imageWrapper) => observer.observe(imageWrapper));
});

document.addEventListener("DOMContentLoaded", () => {
  const titleWrappers = document.querySelectorAll(
    ".desktop-slider .title-wrapper"
  );
  const imageWrappers = document.querySelectorAll(
    ".desktop-slider .image-wrapper"
  );

  titleWrappers.forEach((titleWrapper, index) => {
    titleWrapper.addEventListener("mouseenter", () => {
      imageWrappers.forEach((image) => image.classList.remove("active"));
      titleWrappers.forEach((title) => title.classList.remove("active"));

      imageWrappers[index].classList.add("active");
      titleWrapper.classList.add("active");
    });
  });
});
